import { StyleSheet, View, Text, TouchableHighlight } from '../base_components';
import React from 'react';

const BUTTON_WIDTH = 561 * 0.021 + 'em';
const BUTTON_HEIGHT = 196 * 0.021 + 'em';

const styles = StyleSheet.create({
  dialogButton: {
    width: BUTTON_WIDTH,
    height: BUTTON_HEIGHT,
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginTop: '0.4em',
    color: 'white',
    fontSize: '1.3em',
  },
});

type Props = {
  style?: any;
  text: string;
  onPress: (_: any) => void;
};

export default class DialogButton extends React.PureComponent<Props> {
  render() {
    const { style, text, onPress } = this.props;

    return (
      <View style={[styles.dialogButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor={'rgba(0,0,0,0.2)'}
          onPress={onPress}
        >
          <View style={styles.inner}>
            <Text style={styles.text}>{text}</Text>
          </View>
        </TouchableHighlight>
      </View>
    );
  }
}
